import { Col } from "react-bootstrap";
import React from "react";
import TextComponent from "./TextComponent";

function Domain({
  structure,
  setDomain,
  lockDomain,
  teacherMode
}) {
  return /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(TextComponent, {
    onChangeSetFunction: setDomain,
    errorProperty: structure.domain.errorMessage,
    textInputLabel: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("var", null, "D"), " = {"),
    onLockFunction: lockDomain,
    textData: structure.domain,
    teacherMode: teacherMode,
    idName: 'language-editor-domain',
    labelText: "Domain"
  }));
}

export default Domain;